(function () {
  var cookieBanner = document.querySelector("[data-atlas-cookie-banner]");

  if (cookieBanner) {
    var cookieChoice = window.localStorage && localStorage.getItem("atlas_cookie_choice");

    if (cookieChoice) {
      cookieBanner.classList.add("is-hidden");
    }

    cookieBanner.querySelectorAll("[data-atlas-cookie-choice]").forEach(function (button) {
      button.addEventListener("click", function () {
        if (window.localStorage) {
          localStorage.setItem("atlas_cookie_choice", button.dataset.atlasCookieChoice);
        }
        cookieBanner.classList.add("is-hidden");
      });
    });
  }

  var page = document.querySelector(".atlas-page");
  if (!page) return;

  var floatingNav = page.querySelector(".atlas-floating-nav");
  var intro = page.querySelector(".atlas-intro");
  var navLinks = Array.prototype.slice.call(page.querySelectorAll("[data-atlas-scroll]"));
  var modal = page.querySelector(".atlas-modal");
  var modalTitle = page.querySelector("[data-modal-title]");
  var modalCategory = page.querySelector("[data-modal-category]");
  var modalDescription = page.querySelector("[data-modal-description]");
  var modalFeatures = page.querySelector("[data-modal-features]");
  var modalPreview = page.querySelector("[data-modal-preview]");
  var modalCta = page.querySelector("[data-modal-cta]");
  var contactForm = page.querySelector(".atlas-form");
  var previousFocus = null;

  function scrollToTarget(selector) {
    var target = document.querySelector(selector);
    if (target) target.scrollIntoView({ behavior: "smooth" });
  }

  if (intro) {
    window.setTimeout(function () {
      if (intro && intro.parentNode) intro.parentNode.removeChild(intro);
    }, 3300);
  }

  navLinks.forEach(function (link) {
    link.addEventListener("click", function (event) {
      var target = link.getAttribute("href") || link.dataset.atlasScroll;
      if (target && target.charAt(0) === "#") {
        event.preventDefault();
        scrollToTarget(target);
      }
    });
  });

  window.addEventListener("scroll", function () {
    if (!floatingNav) return;
    floatingNav.classList.toggle("is-visible", window.scrollY > 300);
  }, { passive: true });

  page.querySelectorAll("[data-service-scroll]").forEach(function (button) {
    button.addEventListener("click", function () {
      var track = page.querySelector(".atlas-service-track");
      if (!track) return;
      var amount = track.offsetWidth * 0.8;
      track.scrollBy({ left: amount * Number(button.dataset.serviceScroll), behavior: "smooth" });
    });
  });

  function openModal(card) {
    if (!modal) return;
    previousFocus = document.activeElement;
    var template = JSON.parse(card.querySelector("script[type='application/json']").textContent);
    modalTitle.textContent = template.name;
    modalCategory.textContent = template.category;
    modalDescription.textContent = template.description;
    modalPreview.src = template.fullPreview;
    modalPreview.alt = "Full preview of " + template.name + " template";
    modalFeatures.innerHTML = "";
    template.features.forEach(function (feature) {
      var item = document.createElement("div");
      item.className = "atlas-feature";
      item.textContent = feature;
      modalFeatures.appendChild(item);
    });
    modalCta.onclick = function (event) {
      event.preventDefault();
      closeModal();
      setTimeout(function () { scrollToTarget("#contact"); }, 250);
    };
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    var close = modal.querySelector(".atlas-modal-close");
    if (close) close.focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    if (previousFocus && previousFocus.focus) previousFocus.focus();
  }

  page.querySelectorAll(".atlas-template-card").forEach(function (card) {
    card.addEventListener("click", function () { openModal(card); });
  });

  if (modal) {
    modal.addEventListener("click", function (event) {
      if (event.target === modal || event.target.hasAttribute("data-modal-close")) closeModal();
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && modal.classList.contains("is-open")) closeModal();
    });
  }

  if (contactForm) {
    contactForm.addEventListener("submit", function (event) {
      var note = contactForm.querySelector(".atlas-form-note");
      var submitButton = contactForm.querySelector("button[type='submit']");
      var action = contactForm.getAttribute("action") || window.location.pathname;

      if (!window.fetch || !window.FormData) return;

      event.preventDefault();
      if (note) {
        note.textContent = "";
        note.classList.remove("is-visible", "is-error");
      }
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add("is-loading");
      }

      fetch(action, {
        method: "POST",
        body: new FormData(contactForm),
        credentials: "same-origin"
      }).then(function (response) {
        if (!response.ok) throw new Error("Form submission failed");
        contactForm.reset();
        if (note) {
          note.textContent = "Thank you! Your project idea was sent. We will be in touch soon.";
          note.classList.add("is-visible");
        }
      }).catch(function () {
        if (note) {
          note.textContent = "Something went wrong. Please try again or email atlascreativeweb@gmail.com.";
          note.classList.add("is-visible", "is-error");
        }
      }).finally(function () {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove("is-loading");
        }
      });
    });
  }

})();
